import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDynamicDefinition } from './TypedDefinition'

export const SchemaDynamicPlugin = createSchemaPlugin(
  'Schema.Dynamic',
  SchemaDynamicDefinition
)
